import { render, staticRenderFns } from "./ResidenceType.vue?vue&type=template&id=0757e4a4&scoped=true"
import script from "./ResidenceType.vue?vue&type=script&lang=js"
export * from "./ResidenceType.vue?vue&type=script&lang=js"
import style0 from "./ResidenceType.vue?vue&type=style&index=0&id=0757e4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0757e4a4",
  null
  
)

export default component.exports